let CPB_C_BORDER_TEXT = "";
let CPB_C_TIEBACK_TEXT = "";
let CPB_C_BORDER_COLOR = "";
let CPB_C_TIEBACK_COLOR = "";

document.addEventListener("DOMContentLoaded", () => {
    const customSection = document.querySelector(".cpb_c-section");
    if (!customSection) return;

    const form = document.querySelector(`#${CPB_C_FORMID}`);
    if (!form) return;

    const addToCartButton = document.querySelector(`#ProductSubmitButton-${CPB_C_SECTIONID}`);
    if (!addToCartButton) return;

    // --------- initial values ---------
    customSection.querySelectorAll(".cpb_c-color-options").forEach(group => {
        let groupValue = "";
        for (const option of group.querySelectorAll(".cpb_c-color-option")) {
            if (option.dataset.color) {
                groupValue = option.dataset.color;
                break;
            }
        }

        const textType = group.dataset.textType;
        if (textType === "tieback") {
            CPB_C_TIEBACK_COLOR = groupValue;
        } else if (textType === "border") {
            CPB_C_BORDER_COLOR = groupValue;
        }
    });

    const popup = document.querySelector(".cpb_c-popup");

    // --------- setup input listeners ---------
    customSection.querySelectorAll("input[type='text']").forEach(input => {
        input.value = "";

        input.addEventListener("input", (e) => {
            const value = e.target.value;
            const textType = input.dataset.textType;
            
            if (textType === "tieback") {
                CPB_C_TIEBACK_TEXT = value && value.length <= 12 ? value : "";
            } else if (textType === "border") {
                CPB_C_BORDER_TEXT = value && value.length <= 15 ? value : "";
            }
        });
    });
    
    // --------- setup clicks ---------
    // zoom image
    customSection.querySelector(".cpb_c-image").addEventListener("click", () => {
        if (popup) {
            popup.style.display = "flex";
        }
    });

    // close image
    document.querySelector(".cpb_c-popup svg").addEventListener("click", () => {
        popup.style.display = "none";
    });

    // colors
    customSection.querySelectorAll(".cpb_c-color-option").forEach(color => {
        color.addEventListener("click", () => {
            const textType = color.parentElement.dataset.textType;
            
            const selectedValue = color.dataset.color;
            if (!selectedValue) return;

            if (textType === "tieback") {
                CPB_C_TIEBACK_COLOR = selectedValue;
            } else if (textType === "border") {
                CPB_C_BORDER_COLOR = selectedValue;
            }

            color.parentElement.querySelectorAll(".cpb_c-color-option").forEach(color2 => {
                color2.classList.remove("selected");
            });

            color.classList.add("selected");
        });
    });

    // buy button
    addToCartButton.addEventListener("click", async (e) => {
        e.preventDefault();

        const customGroupHash = Math.random().toString(36).slice(2,7);

        const fd = new FormData();
        let itemIndex = 0;

        // main product
        const mainProductId = form.querySelector("input[name='items[0][id]']").value;
        fd.append(`items[${itemIndex}][id]`, mainProductId);
        fd.append(`items[${itemIndex}][quantity]`, 1);
        fd.append(`items[${itemIndex}][properties][_group]`, customGroupHash);

        // order note
        const orderNote = document.querySelector(`#tti-note-${CPB_C_SECTIONID}`);
        if (orderNote && orderNote.value) {
            fd.append(`items[${itemIndex}][properties][Additional wishes / questions]`, orderNote.value);
        }

        itemIndex++;

        if (CPB_C_BORDER_TEXT && CPB_C_BORDER_COLOR) {
            fd.append(`items[${itemIndex}][id]`, CPB_C_TEXT_LB_ID);
            fd.append(`items[${itemIndex}][quantity]`, 1);
            fd.append(`items[${itemIndex}][properties][Your Text]`, CPB_C_BORDER_TEXT);
            fd.append(`items[${itemIndex}][properties][Color]`, CPB_C_BORDER_COLOR);
            fd.append(`items[${itemIndex}][properties][_group]`, customGroupHash);
            itemIndex++;
        }

        if (CPB_C_TIEBACK_TEXT && CPB_C_TIEBACK_COLOR) {
            fd.append(`items[${itemIndex}][id]`, CPB_C_TEXT_T_ID);
            fd.append(`items[${itemIndex}][quantity]`, 1);
            fd.append(`items[${itemIndex}][properties][Your Text]`, CPB_C_TIEBACK_TEXT);
            fd.append(`items[${itemIndex}][properties][Color]`, CPB_C_TIEBACK_COLOR);
            fd.append(`items[${itemIndex}][properties][_group]`, customGroupHash);
            itemIndex++;
        }

        const sections = [
            "cart-notification-product",
            "cart-notification-button",
            "cart-icon-bubble"
        ];
        const sectionsUrl = window.location.pathname;

        const response = await fetch(`/cart/add.js?sections=${sections.join(',')}&sections_url=${encodeURIComponent(sectionsUrl)}`, {
            method: "POST",
            body: fd
        });

        const cartResponse = await response.json();

        // extract key
        const keyHTML = cartResponse.sections["cart-notification-product"];
        const keyMatch = keyHTML.match(/id="cart-notification-product-([^"]+)"/);

        const key = keyMatch[1];

        const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

        publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form",
            productVariantId: mainProductId,
            cartData: cartResponse
        });
        CartPerformance.measure("add:paint-updated-sections", () => {
            cartResponse.key = key;
            cart.renderContents(cartResponse);
        });
    });
});